import { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { VictoryLabel, VictoryPie } from 'victory';

const RangeTicketChart = memo(({ ticketsData, handleOpenModal }) => {
  const ticketsColorData = useSelector((state) => state.fuse?.nivelService.totalTickets);
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const [currentData, setCurrentData] = useState(ticketsData.dataTotal);

  const [resolvedStateRender, setResolvedStateRender] = useState(true);
  const [openStateRender, setOpenStateRender] = useState(true);
  const [processingStateRender, setProcessingStateRender] = useState(true);

  const [colorScale, setColorScale] = useState(['#0f83c9', '#ffa640', '#27a027']);

  const initialData = [{ x: 'Cargando', y: 0, start: 1, end: 5 }];

  useEffect(() => {
    if (resolvedStateRender && openStateRender && processingStateRender) {
      setCurrentData(ticketsData.dataTotal);
      setColorScale(['#0f83c9', '#ffa640', '#27a027']);
    }

    if (resolvedStateRender && openStateRender && !processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x !== 'En Curso'));
      setColorScale(['#0f83c9', '#27a027']);
    }
    if (resolvedStateRender && !openStateRender && processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x !== 'Abiertos'));
      setColorScale(['#ffa640', '#27a027']);
    }
    if (!resolvedStateRender && openStateRender && processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x !== 'Resueltos'));
      setColorScale(['#0f83c9', '#ffa640']);
    }

    if (resolvedStateRender && !openStateRender && !processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x === 'Resueltos'));
      setColorScale(['#27a027']);
    }
    if (!resolvedStateRender && openStateRender && !processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x === 'Abiertos'));
      setColorScale(['#0f83c9']);
    }
    if (!resolvedStateRender && !openStateRender && processingStateRender) {
      setCurrentData(ticketsData.dataTotal.filter((rangeTicketData) => rangeTicketData.x === 'En Curso'));
      setColorScale(['#ffa640']);
    }

    if (!resolvedStateRender && !openStateRender && !processingStateRender) {
      setCurrentData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedStateRender, openStateRender, processingStateRender, ticketsData.dataTotal]);

  return (
    <div className="w-full">
      <h2>{ticketsData.nameTotal}</h2>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '10px', justifyContent: 'space-evenly' }}>
        <div
          role="button"
          aria-label="open-tickets-rendering-btn"
          className="ticket-pie-chart-color-section"
          onClick={() => setOpenStateRender(!openStateRender)}
          onKeyDown={() => setOpenStateRender(!openStateRender)}
          tabIndex={0}
          style={{ background: openStateRender ? ticketsColorData[1]?.colorTicket : '#999693', padding: '1rem', margin:'1rem' }}
        />
        <h6> Abiertos</h6>
        <div
          role="button"
          aria-label="processing-tickets-rendering-btn"
          className="ticket-pie-chart-color-section"
          onClick={() => setProcessingStateRender(!processingStateRender)}
          onKeyDown={() => setProcessingStateRender(!processingStateRender)}
          tabIndex={0}
          style={{ background: processingStateRender ? ticketsColorData[2]?.colorTicket : '#999693', padding: '1rem', margin:'1rem' }}
        />
        <h6>En Curso</h6>
        <div
          role="button"
          aria-label="resolved-tickets-rendering-btn"
          className="ticket-pie-chart-color-section"
          onClick={() => setResolvedStateRender(!resolvedStateRender)}
          onKeyDown={() => setResolvedStateRender(!resolvedStateRender)}
          tabIndex={0}
          style={{ background: resolvedStateRender ? ticketsColorData[3]?.colorTicket : '#999693', padding: '1rem', margin:'1rem'}}
        />
        <h6>Resueltos</h6>
      </div>
      <VictoryPie
        // Order by color per data
        colorScale={colorScale}
        data={currentData || initialData}
        labelComponent={<VictoryLabel style={{ fill: darkMode ? '#FFFFFF' : '#000000' }} text={({ datum }) => `${datum.y}`} />}
        style={{ labels: { fontSize: 20, fontWeight: 'bold', color: darkMode ? '#FFFFFF' : '#000000' }, data: { cursor: 'pointer' } }}
        events={[
          {
            target: 'data',
            eventHandlers: {
              onClick: (evt, data) => {
                handleOpenModal(data.datum);
              },
            },
          },
        ]}
      />
    </div>
  );
});

export default RangeTicketChart;
